export default function ({ children }) {
  return (
    <div className="w-full max-w-6xl flex-grow flex flex-col items-center">
      {children}
    </div>
  );
}
